export class StringUtil {
  static normalize(value: string) {
    return value.toLowerCase().replace(/ё/g, 'е').replace(/\s/g, ' ');
  }
}
